<template>
  <div v-if="typeTaxationTlpe">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ getTitle }}
              </h1>
              <breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <button class="button" @click="$router.go(-1)">
              {{ $t('general.button.cancel')}}
            </button>
            <button class="button is-addOrEdit" @click="saveTypeTaxationTlpe()">
              {{ $t('general.button.sauvegarder') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <error-msg-component :messages="messages" class="mgt-20px" :error="error" v-if="error"
                         :messagesChampsVide="messagesChampsVide"
                         :champsVide="champsVide"
                         :title="'addEditBailleur.error.problemOccurred'" :withEmplyFields="true"
                         @close="error = $event"/>
    <div class="columns is-multiline mgt-20px">
      <b-field :label="$t('addEditTypeTaxationTlpe.informationTypeTaxationTlpe.libelle')"
               class="obligatoire column is-5 mgb-0">
        <b-input v-model="typeTaxationTlpe.libelle"></b-input>
      </b-field>
      <div class="column is-7 has-text-right bfieldWhitoutLabel">
        <a class="button is-addOrEdit" @click="addAnneeCivile()">
          {{ $t('addEditTypeTaxationTlpe.actions.addLigne')}}
        </a>
      </div>
      <v-client-table :data='typeTaxationTlpe.typeTaxationTlpeLignes'
                      class="column is-12 displayNoneVuePagination"
                      :columns="columns" :options="options"
                      ref="tableTypeTaxationTlpeLignes">
        <div slot="anneeCivile" slot-scope="props">
          <b-input type="number"
                   @input="updateTypeTaxationTlpeLignes(props.row, 'anneeCivile')"
                   v-model="props.row.anneeCivile">
          </b-input>
        </div>
        <div slot="montantAnnuel" slot-scope="props">
          <input-currency isNumber="true"
                          @input="updateTypeTaxationTlpeLignes(props.row, 'montantAnnuel')"
                          v-model="props.row.montantAnnuel">
          </input-currency>
        </div>
        <div slot="montantSemaine" slot-scope="props">
          <input-currency isNumber="true"
                          @input="updateTypeTaxationTlpeLignes(props.row, 'montantSemaine')"
                          v-model="props.row.montantSemaine">
          </input-currency>
        </div>
        <div slot="delete" slot-scope="props">
          <a @click="deleteTypeTaxeTlpeLigne(props.row.id)">
            <b-icon icon="delete" type="is-danger">
            </b-icon>
          </a>
        </div>
      </v-client-table>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { get, update, create } from '@/api/typeTaxationTlpe';
import genererTypeTaxationTlpe from '@/services/parametrage/generation/genererTypeTaxationTlpe';
import genererTypeTaxationTlpeLigne from '@/services/parametrage/generation/genererTypeTaxationTlpeLigne';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import translator from '@/services/parametrage/translator/translatorTypeTaxationTlpe';
import validation from '@/services/validation/validation';
import validationTypeTaxationTlpe from '@/services/parametrage/validation/validationTypeTaxationTlpe';
import messageSuccess from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import breadcrumb from '@/components/general/breadcrumb';
import inputCurrency from '@/components/general/inputCurrency';

const Societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      typeTaxationTlpe: null,
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      libelle: '',
    };
  },
  components: {
    errorMsgComponent,
    breadcrumb,
    inputCurrency,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    getTitle() {
      if (this.$route.params.id) return this.$i18n.t('addEditTypeTaxationTlpe.titleEdit', { libelle: this.libelle });
      return this.$i18n.t('addEditTypeTaxationTlpe.titleAdd');
    },
    breadcrumb() {
      return [
        { title: this.$t('addEditTypeTaxationTlpe.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('addEditTypeTaxationTlpe.breadcrumb.parametrage'), route: { name: 'l.parametrage.general' }, isActive: false },
        { title: this.$t('addEditTypeTaxationTlpe.breadcrumb.liste'), route: { name: 'l.gabed.type_taxation_tlpe' }, isActive: false },
        { title: this.getTitle, route: { name: '' }, isActive: true },
      ];
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          anneeCivile: this.$t('addEditTypeTaxationTlpe.informationTypeTaxationTlpe.typeTaxationTlpeLignes.anneeCivile'),
          montantSemaine: this.$t('addEditTypeTaxationTlpe.informationTypeTaxationTlpe.typeTaxationTlpeLignes.montantSemaine'),
          montantAnnuel: this.$t('addEditTypeTaxationTlpe.informationTypeTaxationTlpe.typeTaxationTlpeLignes.montantAnnuel'),
          delete: '',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: texts,
        columnsClasses: {
          delete: 'colonneSelected',
        },
        sortable: ['anneeCivile', 'montantAnnuel', 'montantSemaine'],
      };
    },
    columns() {
      return ['anneeCivile', 'montantAnnuel', 'montantSemaine', 'delete'];
    },
  },
  methods: {
    addAnneeCivile() {
      this.typeTaxationTlpe.typeTaxationTlpeLignes.unshift(genererTypeTaxationTlpeLigne());
    },
    updateTypeTaxationTlpeLignes(row, key) {
      const typeTaxationTlpeLigneFind = this.typeTaxationTlpe.typeTaxationTlpeLignes
        .find((ligne) => {
          return ligne.id === row.id;
        });
      if (typeTaxationTlpeLigneFind) this.$set(typeTaxationTlpeLigneFind, key, row[key]);
    },
    deleteTypeTaxeTlpeLigne(id) {
      const index = this.typeTaxationTlpe.typeTaxationTlpeLignes.findIndex((ligne) => {
        return ligne.id === id;
      });
      this.typeTaxationTlpe.typeTaxationTlpeLignes.splice(index, 1);
    },
    async saveTypeTaxationTlpe() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.error = false;
        this.messages = [];
        this.messagesChampsVide = [];
        this.champsVide = [];
        const typeTaxationTlpe = cloneDeep(this.typeTaxationTlpe);
        typeTaxationTlpe.typeTaxationTlpeLignes.forEach((ligne) => {
          if (!ligne.isCreate) return;
          delete ligne.isCreate;
          delete ligne.id;
        });
        if (this.typeTaxationTlpe.id) {
          await update(typeTaxationTlpe);
          messageSuccess(this.$i18n.t('addEditTypeTaxationTlpe.success.edit'));
        } else {
          await create(typeTaxationTlpe);
          messageSuccess(this.$i18n.t('addEditTypeTaxationTlpe.success.add'));
        }
        loadingComponent.close();
        await this.$router.push({ name: 'l.gabed.type_taxation_tlpe' });
      } catch (e) {
        if (e.response && e.response.data.error.validationErrors) {
          validationTypeTaxationTlpe(e.response, this.messages);
          validation(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translator);
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.$route.params.id) {
        this.typeTaxationTlpe = (await get(this.$route.params.id)).data.result;
        this.libelle = cloneDeep(this.typeTaxationTlpe.libelle);
        this.typeTaxationTlpe.typeTaxationTlpeLignes.sort((a, b) => b.anneeCivile - a.anneeCivile);
        this.setInformationPage(this.$t('pageGeneral.modification', { item: this.typeTaxationTlpe.libelle }));
      } else {
        this.typeTaxationTlpe = genererTypeTaxationTlpe(this.societeActiveId);
        this.setInformationPage(this.$t('pageParametrage.typeTaxationTlpe.creation'));
      }
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
